<template>
  <button
    type="button"
    class="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-medium transition"
    :class="variant === 'light'
      ? 'border-slate-200 bg-white text-slate-700 hover:border-cyan-400 hover:text-slate-900'
      : 'border-white/20 bg-white/10 text-slate-100 hover:border-cyan-300/60 hover:bg-white/15'"
    @click="i18n.toggleLocale()"
  >
    <span>{{ i18n.isChinese ? '中' : 'EN' }}</span>
    <span class="text-xs" :class="variant === 'light' ? 'text-slate-400' : 'text-slate-300'">
      {{ i18n.isChinese ? 'English' : '中文' }}
    </span>
  </button>
</template>

<script setup>
import { useI18nStore } from '../../stores/i18n';

defineProps({
  variant: {
    type: String,
    default: 'dark',
  },
});

const i18n = useI18nStore();
</script>
